import { SUBMENU_DEFAULT_VALUE } from '../../../constants/route'
import { postApi } from '../../../utils/api'

import { CONNECTED_REQUEST_FILTER_KEY } from './RequestProfileTabAttachedRequests.constants'

export function getRelatedRequestsFilterStateApi(requestId) {
  return `idwell-api/api/v3/table/filter-states/request-related-requests/${SUBMENU_DEFAULT_VALUE}/?object_id=${requestId}`
}

export function getRelatedRequestsTotalCount({ requestId }) {
  return postApi({
    data: {
      filters: { [CONNECTED_REQUEST_FILTER_KEY]: [requestId] },
    },
    endpoint: 'idwell-api/api/v3/request/requests/filter/total/',
  })
}
